import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col" style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <Navbar />

      <main className="flex-1 max-w-4xl mx-auto px-4 md:px-6 py-12">
        <h1 className="text-3xl md:text-4xl font-bold mb-8">Privacybeleid</h1>
        
        <div className="prose prose-invert max-w-none space-y-8">
          <p className="text-white/70 text-lg">
            Laatst bijgewerkt: {new Date().toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' })}
          </p>

          <section className="bg-white/5 border border-white/10 rounded-2xl p-6">
            <h2 className="text-xl font-semibold mb-4">1. Wie zijn wij?</h2>
            <p className="text-white/70">
              VindJouwBandLid.nl is een initiatief van Tapsody. Wij helpen muzikanten en bands om elkaar te vinden in Nederland en België. 
              Je privacy is belangrijk voor ons en we gaan zorgvuldig om met je gegevens.
            </p>
          </section>

          <section className="bg-white/5 border border-white/10 rounded-2xl p-6">
            <h2 className="text-xl font-semibold mb-4">2. Welke gegevens verzamelen we?</h2>
            <p className="text-white/70 mb-4">We verzamelen de volgende gegevens:</p>
            <ul className="text-white/70 space-y-2 list-disc list-inside">
              <li><strong className="text-white">Accountgegevens:</strong> e-mailadres en wachtwoord (versleuteld)</li>
              <li><strong className="text-white">Profielgegevens:</strong> naam/artiestennaam, locatie, instrumenten, genres, ervaring, bio, profielfoto</li>
              <li><strong className="text-white">Oproepen:</strong> titel, beschrijving, gezochte instrumenten, genres</li>
              <li><strong className="text-white">Berichten:</strong> communicatie tussen gebruikers via het platform</li>
              <li><strong className="text-white">Medialinks:</strong> optionele links naar YouTube, SoundCloud, Spotify</li>
            </ul>
          </section>

          <section className="bg-white/5 border border-white/10 rounded-2xl p-6">
            <h2 className="text-xl font-semibold mb-4">3. Waarvoor gebruiken we je gegevens?</h2>
            <ul className="text-white/70 space-y-2 list-disc list-inside">
              <li>Om je account aan te maken en te beheren</li>
              <li>Om je profiel zichtbaar te maken voor andere muzikanten</li>
              <li>Om matches te berekenen op basis van genre, locatie en ervaring</li>
              <li>Om contact tussen gebruikers mogelijk te maken</li>
              <li>Om het platform te verbeteren</li>
            </ul>
          </section>

          <section className="bg-white/5 border border-white/10 rounded-2xl p-6">
            <h2 className="text-xl font-semibold mb-4">4. Wie kan je gegevens zien?</h2>
            <p className="text-white/70 mb-4">
              Je profielgegevens en oproepen zijn zichtbaar voor andere ingelogde gebruikers van VindJouwBandLid.nl. 
              Je e-mailadres wordt <strong className="text-white">nooit</strong> gedeeld met andere gebruikers.
            </p>
            <p className="text-white/70">
              We verkopen je gegevens niet aan derden en gebruiken ze niet voor advertenties.
            </p>
          </section>

          <section className="bg-white/5 border border-white/10 rounded-2xl p-6">
            <h2 className="text-xl font-semibold mb-4">5. Hoe lang bewaren we je gegevens?</h2>
            <p className="text-white/70">
              We bewaren je gegevens zolang je account actief is. Als je je account verwijdert, worden al je gegevens 
              (profiel, oproepen, berichten, foto's) permanent verwijderd uit ons systeem.
            </p>
          </section>

          <section className="bg-white/5 border border-white/10 rounded-2xl p-6">
            <h2 className="text-xl font-semibold mb-4">6. Je rechten (AVG/GDPR)</h2>
            <p className="text-white/70 mb-4">Onder de Europese privacywetgeving heb je de volgende rechten:</p>
            <ul className="text-white/70 space-y-2 list-disc list-inside">
              <li><strong className="text-white">Inzage:</strong> je kunt je gegevens bekijken in je profiel</li>
              <li><strong className="text-white">Correctie:</strong> je kunt je gegevens aanpassen via je profiel</li>
              <li><strong className="text-white">Verwijdering:</strong> je kunt je account en alle gegevens verwijderen via de instellingen</li>
              <li><strong className="text-white">Bezwaar:</strong> je kunt contact met ons opnemen via helpdesk@tapsody.app</li>
            </ul>
          </section>

          <section className="bg-white/5 border border-white/10 rounded-2xl p-6">
            <h2 className="text-xl font-semibold mb-4">7. Beveiliging</h2>
            <p className="text-white/70">
              We gebruiken Firebase (Google Cloud) voor het opslaan van gegevens. Alle communicatie verloopt via HTTPS. 
              Wachtwoorden worden versleuteld opgeslagen en zijn niet voor ons zichtbaar.
            </p>
          </section>

          <section className="bg-white/5 border border-white/10 rounded-2xl p-6">
            <h2 className="text-xl font-semibold mb-4">8. Tapsody koppeling</h2>
            <p className="text-white/70">
              Als je ook Tapsody gebruikt, kun je inloggen met dezelfde gegevens. Je Tapsody-bandgegevens kunnen 
              optioneel geïmporteerd worden naar je VindJouwBandLid profiel. Dit gebeurt alleen met jouw toestemming.
            </p>
          </section>

          <section className="bg-white/5 border border-white/10 rounded-2xl p-6">
            <h2 className="text-xl font-semibold mb-4">9. Contact</h2>
            <p className="text-white/70">
              Vragen over je privacy? Neem contact op via{' '}
              <a href="mailto:helpdesk@tapsody.app" className="text-[#8146FF] hover:underline">
                helpdesk@tapsody.app
              </a>
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
